import { DOCTYPES } from '@/constants/doctypes'
import { PERMISSIONS } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeCalendarHome, root: routeCalendarRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.CONTACT]: [PERMISSIONS.SELECT, PERMISSIONS.READ],
    [DOCTYPES.CUSTOMER]: [PERMISSIONS.READ],
    [DOCTYPES.EVENT]: [PERMISSIONS.READ],
    [DOCTYPES.SALES_PARTNER]: [PERMISSIONS.READ],
    [DOCTYPES.SUPPLIER]: [PERMISSIONS.READ],
  },
  name: 'calendar-home',
  path: 'calendar',
  view: async () => await import('@/components/views/calendar/CalendarView.vue'),
})

export { routeCalendarHome, routeCalendarRoot }
